import styled from 'styled-components';

import { breakpoints } from '../../../../constants';

export const TopText = styled.h5`
    font-size: 16px;

    @media (${breakpoints.mediumMin}) {
        font-size: 18px;
    }
`;
